import { ShareLinkMessengerMessage } from './type/ShareLinkMessengerMessage';
import Action from '../action/Action';
import isShareLinkMessengerMessage from './is-slm-message';

type T = (message: ShareLinkMessengerMessage) => boolean;

const f: T = (message) =>
    isShareLinkMessengerMessage(message) &&
    message.action === Action.NEW_URL &&
    Object.prototype.hasOwnProperty.call(message.payload, 'url');

export default f;
